export default "__VITE_ASSET__DSmb7L4___"